.list {
  scrollbar-width: none;
}

.list::-webkit-scrollbar {
  display: none;
}
